export const MEMBER_STATUS = {
  NORMAL: 1,
  PENDING: 2,
  DELETED: 3,
};

export const MEMBER_STATUS_STRING = [
  '정상',
  '중지',
  '삭제'
];